/** Testers-only demo tools. Real buyers never see these.
 * Unlock with ?tester=1 on the chat URL (stays on for this tab).
 * ?tester=0 turns it off.
 */

import {
  clearHandsFreePreference,
  clearLegacyHandsFreePreference,
  clearStoredConversationId,
  takeHandoff,
} from './buyerChatSession';
import { clearResumeRecap } from './chatResumeRecap';

export const TESTER_STORAGE_KEY = 'a4a_tester';

function readTesterFlag() {
  try {
    return sessionStorage.getItem(TESTER_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function syncTesterModeFromSearch(search) {
  const params = new URLSearchParams(typeof search === 'string' ? search : '');
  const raw = params.get('tester');
  if (raw === '1' || raw === 'true') {
    try { sessionStorage.setItem(TESTER_STORAGE_KEY, '1'); } catch { /* ignore */ }
    return true;
  }
  if (raw === '0' || raw === 'false') {
    try { sessionStorage.removeItem(TESTER_STORAGE_KEY); } catch { /* ignore */ }
    return false;
  }
  return readTesterFlag();
}

export function isTesterMode() {
  return readTesterFlag();
}

function removePrefixedKeys(store, prefix) {
  if (!store || !prefix) return;
  const keys = [];
  for (let i = 0; i < store.length; i += 1) {
    const key = store.key(i);
    if (key && key.startsWith(prefix)) keys.push(key);
  }
  keys.forEach((key) => store.removeItem(key));
}

/** Wipe this agent's buyer-demo pointers so the next load is a first visit. */
export function clearBuyerDemoSession(agentSlug) {
  if (!agentSlug) return;
  clearStoredConversationId(agentSlug);
  clearLegacyHandsFreePreference(agentSlug);
  clearHandsFreePreference(agentSlug);
  takeHandoff(agentSlug);
  clearResumeRecap(agentSlug);
  try {
    localStorage.removeItem(`a4a_draft_criteria_${agentSlug}`);
    localStorage.removeItem(`a4a_saved_${agentSlug}`);
    localStorage.removeItem(`a4a_save_prompt_dismissed_${agentSlug}`);
    localStorage.removeItem(`a4a_save_card_auto_shown_${agentSlug}`);
    localStorage.removeItem(`a4a_save_card_strong_reoffer_${agentSlug}`);
    removePrefixedKeys(sessionStorage, `a4a_handsfree_${agentSlug}`);
    removePrefixedKeys(sessionStorage, `a4a_chat_handoff_${agentSlug}`);
  } catch { /* ignore */ }
}

export function testerLandingHref(agentSlug) {
  return `/chat/${agentSlug}?tester=1`;
}

/** Privacy/Terms open in a new tab, which loses the per-tab tester flag. Carry it across so Back lands on the tester chat. */
export function legalHref(path) {
  try {
    const m = window.location.pathname.match(/^\/chat\/([^/]+)/);
    if (isTesterMode() && m) return `${path}?tester=1&from=${encodeURIComponent(m[1])}`;
  } catch { /* ignore */ }
  return path;
}
